export default "__VITE_PUBLIC_ASSET__6640a6de__"